export const RESET_PASSWORD_RESET = 'RESET_PASSWORD_RESET'
export const RESET_PASSWORD_SET_ERROR = 'RESET_PASSWORD_SET_ERROR'
export const RESET_PASSWORD_SET_VIOLATIONS = 'RESET_PASSWORD_SET_VIOLATIONS'
export const RESET_PASSWORD_TOGGLE_LOADING = 'RESET_PASSWORD_TOGGLE_LOADING'
export const RESET_PASSWORD_SET_UPDATED = 'RESET_PASSWORD_SET_UPDATED'
export const RESET_PASSWORD_SET_EXPIRED_TOKEN = 'RESET_PASSWORD_SET_EXPIRED_TOKEN'
export const RESET_PASSWORD_SET_INVALID_TOKEN = 'RESET_PASSWORD_SET_INVALID_TOKEN'
